import React from 'react';

import { IconPlus } from '../Icon';
import { Button } from './wrapper';

interface AddButtonProps {
  children: React.ReactNode;
  title: string;
  disabled?: boolean;
  error?: boolean;
  isDragActive?: boolean;
  inputHeight?: boolean;
  icon?: React.ReactNode;
  onClick: () => void;
}

const AddButton = ({
  children,
  title,
  disabled,
  error,
  isDragActive,
  inputHeight,
  icon,
  onClick,
}: AddButtonProps) => (
  <Button
    onClick={onClick}
    title={title}
    disabled={disabled}
    $isDragActive={isDragActive}
    $hasError={error}
    $inputHeight={inputHeight}
  >
    {icon || <IconPlus />}
    {children}
  </Button>
);

export default AddButton;
